import { isNotFoundError } from "@/utils/error"

export function orderPreferredFileNames(
	preferred: string,
	supportedFileNames: readonly string[],
): string[] {
	const preferredLower = preferred.toLowerCase()
	return [
		preferred,
		...supportedFileNames.filter((fileName) => fileName.toLowerCase() !== preferredLower),
	]
}

export function isKnownFileName(fileName: string, supportedFileNames: readonly string[]): boolean {
	const lower = fileName.toLowerCase()
	return supportedFileNames.some((supportedFileName) => supportedFileName.toLowerCase() === lower)
}

export async function findExistingFileName(
	directory: FileSystemDirectoryHandle,
	candidates: readonly string[],
): Promise<string | null> {
	for (const candidate of candidates) {
		try {
			await directory.getFileHandle(candidate, { create: false })
			return candidate
		} catch (error) {
			if (!isNotFoundError(error)) {
				throw error
			}
		}
	}

	return null
}

export async function resolveFileName(
	directory: FileSystemDirectoryHandle,
	preferred: string,
	candidates: readonly string[],
): Promise<string> {
	return (await findExistingFileName(directory, candidates)) ?? preferred
}
